import { AppVariants } from "common/types/appVariant";

import { useFeatureFlag } from "features/feature-flags";
import useIsGoStudentLearningApp from "features/goStudentLearning/hooks/useIsGoStudentLearningApp";
import { useIsPlurallApp } from "features/plurall";

export default function useAppVariant() {
  const isPlurallApp = useIsPlurallApp();
  const isGoStudentLearningApp = useIsGoStudentLearningApp();
  const isPrimaryApp = useFeatureFlag("isPrimaryApp");

  if (isPlurallApp) return AppVariants.plurall;
  if (isGoStudentLearningApp) return AppVariants.goStudentLearning;
  if (isPrimaryApp) return AppVariants.senecaPrimary;

  return AppVariants.seneca;
}
